import {
  Busy_Professionals,
  Fiteness_Enthusisasts,
  Fitness,
  YearWellness,
  Go_Getters,
  Active_Adults,
  Running_blackman,
  Think_Go_Getter,
  active_Adult_FireFighter,
  low_Energy,
  prevent_Health_Seaker,
  Busy_Professionals_Shipping,
  Wellness_Sunset,
  Running_In_RedShirt,
  Busy_Professionals_Tablet,
  Concern_About_Aging,
  Wellness_Hiking,
  Running_In_Beach,
  Benefits_Hiking,
  Bone_Advocate,
  Biking_View,
  Active_Parent_Hiking,
  Busy_Professionals_Papers,
} from '../../src/images';

export const content = {
  TNK: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Busy Professionals',
        description:
          'Enhance mental clarity to tackle work projects, outshine competition, and thrive in demanding careers.*',
        image: Busy_Professionals,
      },
      {
        title: 'Competitive Go-Getters',
        description:
          'Whether you’re climbing the corporate ladder or looking for a mental edge in any major project, Think Factor can help you stay ahead of the game.*',
        image: Think_Go_Getter,
      },
      {
        title: 'Active Adults & Students',
        description:
          'Support sharper focus and recall during challenging tasks or study sessions. If you want to stay sharp, support your memory, and maintain vibrant vision, Think Factor is for you.*',
        image: Active_Adults,
      },
    ],
  },
  ACB: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Busy Professionals',
        description: 'Looking to support immune health and daily vitality.',
        image: Busy_Professionals_Tablet,
      },
      {
        title: 'Active Adults',
        description:
          'Seeking to recover faster from workouts and maintain healthy inflammatory responses.',
        image: Wellness_Hiking,
      },
      {
        title: 'Anyone Concerned About Aging',
        description:
          'Who wants to nourish their body with a robust antioxidant defense.',
        image: Concern_About_Aging,
      },
    ],
  },
  FSE: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Adults seeking antioxidant protection',
        description:
          'Great for those looking to support heart, immune, and overall wellness.',
        image: Biking_View,
      },
      {
        title: 'Fitness Enthusiasts',
        description:
          'Helps combat oxidative stress from workouts and daily life.',
        image: Running_blackman,
      },
      {
        title: 'Professionals & Busy Parents',
        description:
          'The added cognitive support from DMAE Bitartrate helps keep you on top of your mental game.',
        image: Active_Parent_Hiking,
      },
    ],
  },
  IMF: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Busy Professionals',
        description: 'Stay on top of your game even when life gets hectic.',
        image: Busy_Professionals_Shipping,
      },
      {
        title: 'Fitness Enthusiasts',
        description:
          'Support a strong immune system to keep up with workouts or outdoor adventures.',
        image: Running_In_RedShirt,
      },
      {
        title: 'Year-Round Wellness',
        description:
          'Ideal for anyone who wants a daily approach to fortify their immune health.',
        image: Wellness_Sunset,
      },
    ],
  },
  NAC: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Busy Professionals & Parents',
        description: 'Looking for extra immune and detox support.',
        image: Active_Parent_Hiking,
      },
      {
        title: 'Active Individuals',
        description:
          'Wanting to optimize recovery and daily antioxidant defense.',
        image: Running_blackman,
      },
      {
        title: 'Health Enthusiasts',
        description:
          'If you’re seeking a simple yet effective way to bolster nutrient synergy and overall wellness.',
        image: Wellness_Sunset,
      },
    ],
  },
  BER: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Metabolic Balance Seekers',
        description:
          ' If you’re watching your diet and exercise but want extra support for healthy blood sugar and weight management.',
        image: Running_In_RedShirt,
      },
      {
        title: 'Active Lifestyles',
        description:
          'Perfect for individuals juggling a busy schedule who need to maintain stable energy levels.',
        image: Benefits_Hiking,
      },
      {
        title: 'Heart and Digestive Health Focused',
        description:
          ' Berberine is a revered herbal ally for overall well-being.',
        image: Running_In_Beach,
      },
    ],
  },
  VBC: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Busy Professionals & Students',
        description:
          'Run-down from modern stress and looking for sustained energy, mental clarity and restored balance.',
        image: Busy_Professionals_Shipping,
      },
      {
        title: 'Health-Conscious Individuals',
        description:
          'Health-Conscious Individuals aiming to fill nutritional gaps in their daily diet.',
        image: Bone_Advocate,
      },
      {
        title: 'Active Lifestyles',
        description:
          'Fitness enthusiasts, athletes who need extra support for metabolism and recovery.',
        image: Wellness_Hiking,
      },
    ],
  },
  RYR: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Adults 40+',
        description:
          'Looking to maintain healthy cholesterol levels without overspending.',
        image: Benefits_Hiking,
      },
      {
        title: 'Busy professionals',
        description:
          'Convenient, daily heart support and overall cardiovascular health.',
        image: active_Adult_FireFighter,
      },
      {
        title: 'Active Lifestyle',
        description:
          'A balanced and natural approach to cardiovascular wellness.',
        image: Biking_View,
      },
    ],
  },
  VEP: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Heart Health Advocates',
        description:
          ' If you want an effective way to keep homocysteine levels in check and support healthy blood vessels.',
        image: active_Adult_FireFighter,
      },
      {
        title: 'Low-Energy Individuals',
        description:
          'If you feel run down, experience brain fog, and want more energy throughout the day.',
        image: low_Energy,
      },
      {
        title: 'Preventive Health Seekers',
        description:
          'Perfect for those taking a proactive stance on long-term wellness. You won’t find synthetic fillers here—just clean, straightforward ingredients.',
        image: prevent_Health_Seaker,
      },
    ],
  },
  DK2: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Bone Health Advocates',
        description:
          'Whether you’re staying active or just want extra support as you age.',
        image: Bone_Advocate,
      },
      {
        title: 'Heart Health Conscious',
        description:
          'K2 is crucial for directing calcium away from your arteries keeping your heart healthy.',
        image: Concern_About_Aging,
      },
      {
        title: 'Busy Lifestyles',
        description:
          'If you need a simple, once-a-day supplement to fill nutrient gaps and support your immune system.',
        image: Busy_Professionals_Papers,
      },
    ],
  },
  DK5: {
    headline: 'Who Benefits Most',
    items: [
      {
        title: 'Bone Health Advocates',
        description:
          'Whether you’re staying active or just want extra support as you age.',
        image: Bone_Advocate,
      },
      {
        title: 'Heart Health Conscious',
        description:
          'K2 is crucial for directing calcium away from your arteries keeping your heart healthy.',
        image: Concern_About_Aging,
      },
      {
        title: 'Busy Lifestyles',
        description:
          'If you need a simple, once-a-day supplement to fill nutrient gaps and support your immune system.',
        image: Busy_Professionals_Papers,
      },
    ],
  },
};
